import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigDownDash: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M15 5H9' }],
    ['path', { d: 'M15 9v3h4l-7 7-7-7h4V9h6z' }],
  ],
];

export default ArrowBigDownDash;
